var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVenda1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 29V24.9832H14.0569V27.7097H16.2901V29H13ZM25.7099 29V27.7097H27.9431V24.9832H29V29H25.7099ZM15.0494 26.5428V15.4348H16.5106V26.5428H15.0494ZM17.255 26.5428V15.4348H18.0178V26.5428H17.255ZM19.479 26.5428V15.4348H20.9954V26.5428H19.479ZM21.7582 26.5428V15.4348H23.973V26.5428H21.7582ZM24.7358 26.5428V15.4348H25.4986V26.5428H24.7358ZM26.2522 26.5428V15.4348H26.9414V26.5428H26.2522ZM13 17.0168V13H16.2901V14.2903H14.0569V17.0168H13ZM27.9431 17.0168V14.2903H25.7099V13H29V17.0168H27.9431Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVenda1);
export default __webpack_public_path__ + "static/media/icon-venda-1.82e5660c.svg";
export { ForwardRef as ReactComponent };